import React, { useEffect, useState } from 'react';

export const getChildCategories = (categories, parentId) =>
    categories.filter((item) => Number(item.parentCategoryId) === Number(parentId));

export const buildCategoryPath = (categories, categoryId) => {
    if (!categoryId || !categories.length) return [];

    const path = [];
    let current = categories.find((c) => Number(c.id) === Number(categoryId));

    while (current) {
        path.unshift(Number(current.id));
        if (Number(current.parentCategoryId) === 0) break;
        current = categories.find(
            (c) => Number(c.id) === Number(current.parentCategoryId)
        );
    }

    return path;
};

export default function CategoryTreeSelect({ categories, value, onChange }) {
    const [categoryPath, setCategoryPath] = useState([]);

    useEffect(() => {
        if (value && categories.length > 0) {
            setCategoryPath(buildCategoryPath(categories, value));
        }
    }, [value, categories]);

    const handleLevelChange = (level, selectedId) => {
        const id = selectedId ? Number(selectedId) : null;
        const newPath = categoryPath.slice(0, level);

        if (id) {
            newPath[level] = id;
            setCategoryPath(newPath);

            const children = getChildCategories(categories, id);
            if (children.length === 0) {
                onChange(id);
            } else {
                onChange('');
            }
        } else {
            setCategoryPath(newPath);
            onChange('');
        }
    };

    const renderSelectors = () => {
        const selectors = [];
        let parentId = 0;

        for (let level = 0; ; level += 1) {
            const options = getChildCategories(categories, parentId);
            if (options.length === 0) break;

            const selectedId = categoryPath[level] ?? '';
            const label = level === 0 ? 'Category' : 'Subcategory';

            selectors.push(
                <div key={level} className="mb-2">
                    <label className="form-label small text-muted mb-1">{label}</label>
                    <select
                        className="form-select form-select-sm"
                        value={selectedId}
                        onChange={(e) => handleLevelChange(level, e.target.value)}
                    >
                        <option value="">-- Select {label.toLowerCase()} --</option>
                        {options.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.title}
                            </option>
                        ))}
                    </select>
                </div>
            );

            if (!selectedId) break;

            const children = getChildCategories(categories, Number(selectedId));
            if (children.length === 0) break;

            parentId = Number(selectedId);
        }

        return selectors;
    };

    if (!categories.length) {
        return (
            <select className="form-select form-select-sm" disabled>
                <option>Loading categories...</option>
            </select>
        );
    }

    return <div>{renderSelectors()}</div>;
}
